import { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom"
import AppHeader from "../Components/Header/AppHeader";
import useProfileData from "../hooks/useProfileData";
import AdminNavbar from "../Components/Navbars/AdminNavbar";

function AdminRoute({ children }) {
//   TODO: change the EmpId from "1068" to something which is unique to Admin
// because this is required for admin routes only.
  let jwt = localStorage.getItem("JwtToken");
  let userData = JSON.parse(localStorage.getItem("userData"));
  const userRole = userData.userRole;
  const isSalesNetUser = userData.isSalesNetUser;
  const { profileData } = useProfileData();
  const { pathname } = useLocation();

  useEffect(() => {
    document.title = "Techlabs";
  }, [])

  // if there is no user logged in, then
  if(!jwt) {    
    return <Navigate to="/" />
  }
  // if there is a user logged in, but that user is not an admin
  if(userRole !== "Administrator" || !isSalesNetUser) {
    return (
      <Navigate to="/Dashboard" />
    )
  }  
  return <>
    
    {
      (pathname === '/Dashboard') || 
      (pathname === '/HrEmployeeList') ||
      (pathname === '/HrEmpTargetList') || 
      (pathname === "/HrEmpTarget") ? null : 
      <div className="sticky-nav">
        <AppHeader data={profileData} />
        {/* {
          profileData.userRole === "Administrator" && <AdminNavbar />
        } */}
      </div>
    }

      {children}
  </>
}

export default AdminRoute;
